import { BuildProvisioningFile, BuildProvisioningRegistration } from 'types/GameHosting/build-provisioning';
import { ErrorAction, FetchAction, PendingAction } from 'types/services/redux-action';

export const FETCH_BUILD_PROVISIONING_REGISTRATION = 'FETCH_BUILD_PROVISIONING';

export const FETCH_BUILD_PROVISIONING_REGISTRATION_IS_PENDING = 'FETCH_BUILD_PROVISIONING_REGISTRATION_IS_PENDING';

export const FETCH_BUILD_PROVISIONING_REGISTRATION_IS_ERROR = 'FETCH_BUILD_PROVISIONING_REGISTRATION_IS_ERROR';

export const FETCH_BUILD_PROVISIONING_FILES = 'FETCH_BUILD_PROVISIONING_FILES';

export const FETCH_BUILD_PROVISIONING_FILES_IS_PENDING = 'FETCH_BUILD_PROVISIONING_FILES_IS_PENDING';

export const FETCH_BUILD_PROVISIONING_FILES_IS_ERROR = 'FETCH_BUILD_PROVISIONING_FILES_IS_ERROR';

export const SORT = 'SORT_BUILD_PROVISIONING_REGISTRATION';

export const RESET_BUILD_PROVISIONING_REGISTRATION = 'RESET_BUILD_PROVISIONING_REGISTRATION';

export type BuildProvisioningReducerState = {
  buildProvisioningRegistration: BuildProvisioningRegistration[] | undefined;
  buildProvisioningRegistrationIsCompleted: boolean;
  buildProvisioningRegistrationIsPending: boolean;
  buildProvisioningRegistrationIsError: null | boolean;
  buildProvisioningFiles: BuildProvisioningFile[] | undefined;
  buildProvisioningFilesIsCompleted: boolean;
  buildProvisioningFilesIsPending: boolean;
  buildProvisioningFilesIsError: null | boolean;
};

export type BuildProvisioningActions =
  | FetchAction<'FETCH_BUILD_PROVISIONING', BuildProvisioningRegistration[]>
  | PendingAction<'FETCH_BUILD_PROVISIONING_REGISTRATION_IS_PENDING'>
  | ErrorAction<`FETCH_BUILD_PROVISIONING_REGISTRATION_IS_ERROR`>
  | FetchAction<'FETCH_BUILD_PROVISIONING_FILES', BuildProvisioningFile[]>
  | PendingAction<'FETCH_BUILD_PROVISIONING_FILES_IS_PENDING'>
  | ErrorAction<`FETCH_BUILD_PROVISIONING_FILES_IS_ERROR`>
  | { type: 'RESET_BUILD_PROVISIONING_REGISTRATION' };
